import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-unit',
  templateUrl: './unit.component.html',
  styleUrls: ['./unit.component.css']
})
export class UnitComponent implements OnInit {

  unitList = [];
  model = { 'table_name': 'unit', 'unit_id': '0', 'unit_name': '', 'unit_name_en': '', 'comment': '' };
  // , 'unit_type': 'primary', 'from_unit': '0', 'quantity': '0'

  Success_Msg; Error_Msg; Unit_Name_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<UnitComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Unit_Name_Msg').subscribe((res: string) => {
      this.Unit_Name_Msg = res;
    });

  }

  ngOnInit() {

    // let query = "SELECT `unit_name`, `unit_id` FROM `unit` WHERE `status`='1'";
    // let obj = { cmd: 'getList', query: query };
    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.unitList = data.data['list'];
    //   });

    if (this.dialog_data != null)
      this.model = this.dialog_data;

  }

  // changeType() {
  //   this.model['from_unit'] = '0';
  //   this.model['quantity'] = '0';
  // }

  add() {
    if (this.model['unit_name'] != '') {
      let values = [];
      values.push(this.model);

      let obj;

      obj = { cmd: 'add', values: values };
      if (this.model['unit_id'] == '0')
        obj = { cmd: 'add', values: values };
      else {
        let where = [{ 'unit_id': this.model['unit_id'] }];
        obj = { cmd: 'update', values: values, where: where };
      }
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            // this.dialog_data = {
            //   'status': data.status['type']
            // };
            this.dialog_data = { 'op_type': 'success' };
            this.dialogRef.close(this.dialog_data);
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
    else if (this.model['unit_name'] == '') {
      alert(this.Unit_Name_Msg);
    }
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}
